import $http from "../../axios";
import * as mutations from './mutations'
import {Notification} from "element-ui";
import {getApiDomain} from "../../util/domains";
export async function downloadTemplate({}) {
    let name = 'saldos_iniciales_contables.xlsx'
    await $http({
        url: '/api/plantilla-saldos-contables',
        method: 'GET',
        responseType: 'blob',
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', name);
        document.body.appendChild(link);
        link.click();
    }).catch((error) => {
        Notification.error({
            title: 'Error!',
            message: error.message,
            type: 'error',
            duration: 3000,
            customClass: 'notification-box',
        });
    })
}
export async function uploadTemplate({state}) {
    let formData = new FormData();
    formData.append('file', state.file);
    state.loading.module = true ;
    $http.post(`/api/importar-saldos-contables`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    ).then(function(response){
        state.loading.module = false ;
        state.file = '' ;
        if (response.data.rows_error > 0){
            window.open(getApiDomain() + response.data.url, '_blank');
            Notification.error({
                title: 'Error',
                message: 'Existen inconsistencias en el archivo cargado',
                type: 'error',
                duration: 5000,
                customClass: 'notification-box',
            });
        }else{
            Notification.success({
                title: "Success!",
                message: 'Archivo cargado',
                type: "success",
                duration: 3000,
                customClass: "notification-box"
            });
        }


    })
        .catch(error => {
            state.loading.module = false ;
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 3000,
                customClass: "notification-box"
            });
        });
}



// WEBPACK FOOTER //
// ./src/modules/import-saldos-contables/actions.js